import { createContext } from 'react';

const SettingsHeadingContext = createContext(null);

export default SettingsHeadingContext;
